import React, { memo } from 'react';
import classnames from 'classnames';

import { Icon, Text, useTheme } from '@Sage/hoi-poi-ui';

const RatesAddItemRow = memo(
    ({ className, hideAction, isAdded, isFolder, label, leading, onAction, onClick }) => {
        const theme = useTheme();

        return (
            <div
                className={classnames('rates-add-item-row', className, {
                    'rates-add-item-row--folder': isFolder,
                })}
                onClick={onClick}
                onKeyDown={onClick ? (e) => e.key === 'Enter' && onClick(e) : undefined}
                role={onClick ? 'button' : undefined}
                tabIndex={onClick ? 0 : undefined}
            >
                {leading ? <div className="rates-add-item-row__leading">{leading}</div> : null}
                <Text className="rates-add-item-row__label" type="body">
                    {label}
                </Text>
                {!hideAction ? (
                    <div className="rates-add-item-row__action">
                        {isAdded ? (
                            <Icon
                                name="taskChecked"
                                size="large"
                                color={theme.colors.semantic.positive500}
                            />
                        ) : (
                            <Icon
                                name="addCircle"
                                size="large"
                                color={theme.colors.grey[400]}
                                onClick={(event) => {
                                    event.stopPropagation();
                                    onAction?.(event);
                                }}
                            />
                        )}
                    </div>
                ) : null}
            </div>
        );
    },
);

RatesAddItemRow.displayName = 'RatesAddItemRow';

export default RatesAddItemRow;
